import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store/store'
import { saveNewColor } from '../../store/modules/SavedColors/slice'

export interface ISavedColor {
  id: string
  color: string
}

function generateTemporaryHash() {
  const timestamp = Date.now().toString(36)
  const randomString = Math.random().toString(36).substring(2, 10)
  return `${timestamp}-${randomString}`
}

export interface IUseSavedColorProps {
  id: string
}

export const useSavedColors = ({ id }: IUseSavedColorProps) => {
  const savedColors = useSelector<RootState, Record<string, ISavedColor[]>>(
    (state) => state.savedColors
  )
  const [focusColor, setFocusColor] = useState<ISavedColor>({
    id: '',
    color: '',
  })

  const dispatch = useDispatch()

  const handleSaveColor = (color: string) => {
    const newColor = { id: generateTemporaryHash(), color }

    if (savedColors[id]?.find((row) => row.color === newColor.color)) return

    dispatch(saveNewColor({ id, color: newColor }))
  }

  return {
    savedColors,
    focusColor,
    setFocusColor,
    handleSaveColor,
  }
}
